import { useMemo } from 'react';

export default function HeartParticles() {
  const hearts = useMemo(
    () =>
      Array.from({ length: 20 }, (_, i) => ({
        id: i,
        left: Math.random() * 96 + 2,
        size: Math.random() * 10 + 6,
        delay: Math.random() * 30,
        duration: Math.random() * 15 + 20,
        opacity: Math.random() * 0.25 + 0.08,
        blur: Math.random() * 2 + 0.5,
      })),
    []
  );

  return (
    <div
      className="fixed inset-0 pointer-events-none overflow-hidden z-0"
      aria-hidden="true"
    >
      {hearts.map((h) => (
        <span
          key={h.id}
          className="heart-float"
          style={{
            left: `${h.left}%`,
            fontSize: `${h.size}px`,
            animationDelay: `${h.delay}s`,
            animationDuration: `${h.duration}s`,
            color: 'var(--accent-light)',
            opacity: h.opacity,
            filter: `blur(${h.blur}px)`,
          }}
        >
          &#9829;
        </span>
      ))}
    </div>
  );
}
